export default "__VITE_ASSET__Djt74Z2n__"